<div class="pagination-box btm-gap-xs" *ngIf="show">

	<div class="page-count">{{ message }}</div>

</div>
